import React from 'react';
import { CheckIcon, CalendarIcon, MessageCircleIcon, CreditCardIcon } from 'lucide-react';
import { mobilePoints } from '../../data/crm';
export function MobileAppSection() {
  return <section className="overflow-hidden bg-brand-black px-4 py-20 sm:px-6 lg:px-8 lg:py-28" data-id="element-256" data-mp="2l7hkmozzn210">
      <div className="mx-auto grid max-w-7xl items-center gap-16 lg:grid-cols-2" data-id="element-257" data-mp="2q616yqihuftw">
        <div data-id="element-258" data-mp="2q856yxd9uuow">
          <h2 className="text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-5xl" data-id="element-259" data-mp="1tgbenrxl6a3t">Run it from your phone</h2>
          <ul className="mt-10 space-y-5" data-id="element-260" data-mp="1xgve525mtpt4">
            {mobilePoints.map(point => <li key={point} className="flex items-center gap-4 text-xl font-semibold text-white" data-id="element-261" data-mp="22g6s63em6h70">
                <span className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-brand-red" data-id="element-262" data-mp="27g302dqfmsru">
                  <CheckIcon className="h-4 w-4" strokeWidth={3} aria-hidden="true" data-id="element-263" data-mp="3dutxg7gcjvh4" />
                </span>
                {point}
              </li>)}
          </ul>
        </div>

        <div className="flex justify-center" aria-hidden="true" data-id="element-264" data-mp="20gwqw898l4i6">
          <div className="w-[280px] rounded-[2.5rem] border-[8px] border-[#1f1f1f] bg-white p-4 shadow-2xl" data-id="element-265" data-mp="1wgcrsz53rqte">
            <div className="mx-auto mb-4 h-5 w-24 rounded-full bg-[#1f1f1f]" data-id="element-266" data-mp="1rh00a13advkh" />
            <p className="text-xs font-bold text-brand-black" data-id="element-267" data-mp="1rj2u6w7k88uh">
              1Dash<span className="text-brand-red" data-id="element-268" data-mp="1mhneljo5iujh">.Pro</span>
            </p>

            <div className="mt-4 rounded-xl bg-brand-light p-3" data-id="element-269" data-mp="1hk3wg8oc1xm9">
              <p className="flex items-center gap-1.5 text-[11px] font-bold text-brand-black" data-id="element-270" data-mp="1cslw9mu4w12c">
                <MessageCircleIcon className="h-3.5 w-3.5 text-brand-red" data-id="element-271" data-mp="18qs1fv6mdra3" /> New lead
              </p>
              <p className="mt-1 text-[11px] text-brand-gray" data-id="element-272" data-mp="13rxhgpwx1woe">“Can someone come look at my AC today?”</p>
              <div className="mt-2 rounded-md bg-white px-2 py-1.5 text-[11px] text-brand-gray" data-id="element-273" data-mp="ysb48gh38gfl">Type a reply…</div>
            </div>

            <div className="mt-3 rounded-xl border border-gray-200 p-3" data-id="element-274" data-mp="tusskiborn3w">
              <p className="flex items-center gap-1.5 text-[11px] font-bold text-brand-black" data-id="element-275" data-mp="k5ceqr1sjw3i">
                <CalendarIcon className="h-3.5 w-3.5 text-brand-red" data-id="element-276" data-mp="p5hzrodk2kcm" /> Today
              </p>
              {[['9:00 AM', 'Drain cleaning'], ['11:30 AM', 'Water heater quote'], ['2:00 PM', 'AC tune-up']].map(([time, job]) => <div key={time} className="mt-2 flex justify-between text-[11px]" data-id="element-277" data-mp="12wn0ktsntioj">
                  <span className="font-semibold text-brand-black" data-id="element-278" data-mp="17vghkw75nrtg">{time}</span>
                  <span className="text-brand-gray" data-id="element-279" data-mp="17xkir6do6cq1">{job}</span>
                </div>)}
            </div>

            <div className="mt-3 flex items-center gap-2 rounded-xl bg-brand-red p-3 text-white" data-id="element-280" data-mp="y5n5zv70jcp7">
              <CreditCardIcon className="h-4 w-4" data-id="element-281" data-mp="1lv974o6y41zu" />
              <span className="text-[11px] font-bold" data-id="element-282" data-mp="1lufwvd8s2ucy">Payment received — $185</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}